import { createContext } from 'react';
import { initialAgendaState } from '../Agenda.constants';

export const AgendaContext = createContext(initialAgendaState);
